<template>
  <div class="flex items-center h-full">
    <vs-button
      color="primary"
      type="border"
      icon-pack="feather"
      icon="icon-eye"
      class="mr-2"
      @click="hanldeViewSidebar"
    ></vs-button>
  </div>
</template>
<script>
// import { Delete_Leads } from '@/api/leads'
import { mapActions } from 'vuex'
export default {
  name: 'PreviewActions',
  
  mounted () {
    this.action = this.params.data.actionData
  },
  data () {
    return {
      action: {}
    }
  },
  methods: {
    ...mapActions([
      'SET_CLIENT_DELETE_ID',
      'SET_VIEW_CLIENT_SIDEBAR',
      'SET_VIEW_CLIENT_SIDEBAR_DATA',
      'SET_CLIENT_TOGGLE_DATA'
    ]),
    hanldeViewSidebar () {
      const viewbutton = true
      this.SET_VIEW_CLIENT_SIDEBAR(viewbutton)
      this.SET_VIEW_CLIENT_SIDEBAR_DATA(this.params.data)
    }
  }
}
</script>
